import React from 'react';
import './works.scss'
import Particle from '../Particle/Particle';
import {
    NavLink
  } from "react-router-dom";
import Icon from '@iconify/react';
import outlineArrowBackIos from '@iconify/icons-ic/outline-arrow-back-ios';


function Works(props) {
    return (
        <>
        <div className="worksFull">
        <NavLink to="/"><Icon icon={outlineArrowBackIos} className="exit exitWeb"></Icon></NavLink> 
            <div className="particle"><Particle  /></div>
            <div className="worksHeader">
                WORKS
                <div className="worksSubHeading">
                 works
                </div>
            </div>
            <div className="webSitesBlock">
                <a className="link" href="https://yarishb.github.io/massageSambir/"><div className="firstWeb"> 
                    <div className="webText">massage</div>
                    <div className="subHeadingWeb">website for masseur</div>
                </div></a>
                <a className="link" href="https://yarishb.github.io/fyf_fnd/"><div className="firstWeb secondWeb"> 
                    <div className="webText secondBlockTextWeb">FEEL YOUR FIT</div>
                    <div className="subHeadingWeb">Fitness website</div>
                </div></a>
            </div>
        </div>
        </>
    );
}

export default Works;